import buildVisualMapGraph from "src/modules/data-protection/pages/admin/software/details/tabs-content/info-cards/data-flow-v2/helpers/buildVisualMapGraph";
import {
    inferWrapperAssetIdFromFlows,
    mergeRelationFlows,
    toFlowCard,
} from "src/modules/data-protection/pages/admin/software/details/tabs-content/info-cards/data-flow-v2/helpers/flowCards";

const EMPTY_GROUPS = {
    receives_from: [],
    sends_to: [],
    relations: [],
};

const buildDataFlowGraph = ({
    softwareName,
    v2,
    methodLabels = {},
    typeLabels = {},
    relationLabels = {},
    t,
}) => {
    const groups = v2 || EMPTY_GROUPS;
    const currentAssetId = inferWrapperAssetIdFromFlows(groups);
    const { incoming, outgoing } = mergeRelationFlows(
        groups.receives_from,
        groups.sends_to,
        groups.relations,
        currentAssetId
    );

    return buildVisualMapGraph({
        softwareName,
        incomingCards: incoming.map((flow) =>
            toFlowCard(flow, "receives", currentAssetId)
        ),
        outgoingCards: outgoing.map((flow) =>
            toFlowCard(flow, "sends", currentAssetId)
        ),
        methodLabels,
        typeLabels,
        relationLabels,
        t,
    });
};

export default buildDataFlowGraph;
